<template>
    <div class="header-banner" :class="{ 'has-coins': hasCoins }">
        <div class="header-banner-text">{{ title }}</div>
    </div>
</template>

<script>
export default {
    props: ['title', 'hasCoins'],
};
</script>

<style lang="scss" scoped>
.header-banner {
    position: relative;
    height: 81px;
    min-width: 100%;
    display: inline-block;

    @media screen and (min-width: 768px) {
        margin: 0 0 3.3rem 5.4rem;
        min-width: 400px;
    }

    .header-banner-text {
        height: 5.4rem;
        background: url('https://images.dundle.com/resources/images/loyalty/sign-paper-middle.svg') top left;
        background-size: 100% contain;
        background-repeat: repeat-x;
        z-index: 2;
        font-weight: 700;
        color: $color-grey-7;
        line-height: 5.1rem;
        text-align: center;
        margin: 0 1rem;
        font-size: 1.4rem;
        padding: 0 1rem 0 1rem;

        @media screen and (min-width: 768px) {
            font-size: 2rem;
            padding: 0 3.3rem 0 3.3rem;
            min-width: 494px;
        }

        @media screen and (max-width: 576px) {
            background-size: cover;
        }
    }

    &::before,
    &::after {
        content: '';
        position: absolute;
        height: 90px;
        width: 65px;
        top: 0.8rem;
    }

    &::before {
        left: 0;
        z-index: -1;
        background: url('https://images.dundle.com/resources/images/loyalty/sign-paper-left.svg');
    }

    &::after {
        right: 0;
        z-index: -1;
        background: url('https://images.dundle.com/resources/images/loyalty/sign-paper-right.svg');
    }

    &.has-coins {
        .header-banner-text {
            &::before {
                content: '';
                position: absolute;
                bottom: -2.3rem;
                left: 0.25rem;
                background: url('https://images.dundle.com/resources/images/loyalty/coins-medium.svg');
                width: 73px;
                height: 78px;

                @media screen and (min-width: 768px) {
                    left: -1.3rem;
                }
            }
        }
    }
}
</style>
